module.exports = __webpack_public_path__ + "static/img/2.828f414b.png";